import { Autocomplete } from './component/Autocomplete.js';
import { checkboxListHandler } from './component/checkboxListHandler.js';
import { callMeAjax } from '../lib/rubberduck/callMeAjax.build.js';

window.ViewportChildrenScale = 1;
window.dictionary = null;

export function setTabsPointer() {
	let container = document.querySelectorAll('.tabs--buttons');
	container.forEach((element) => {
		let btn = element.querySelector('.button.active');
		if (btn == null) return;
		let pointer = btn.querySelector('.pointer');
		if (btn && pointer) {
			let top = (btn.offsetTop + (btn.offsetHeight / 2)) * window.ViewportChildrenScale;
			if (top !== 0) {
				pointer.style.top = top + 'px';
			}
		}
	});
}

export function baseUrl(slug) {
	let url = window.location.pathname;
	url = window.location.protocol + window.location.hostname +
		url.substring(0, url.indexOf('rubberduck') + 'rubberduck'.length) +
		slug;
	return url;
}

export function getTranslation(category_id, term_id, language) {
	if (
		language === undefined ||
		language === null ||
		language === ''
	) {
		language = document.documentElement.getAttribute('lang');
		language = $('html').attr('lang');
	}

	let translation = '';

	if (window.dictionary) {
		if (window.dictionary[category_id]) {
			if (window.dictionary[category_id]['terms']) {
				if (window.dictionary[category_id]['terms'][term_id]) {
					if (window.dictionary[category_id]['terms'][term_id]['content']) {
						if (window.dictionary[category_id]['terms'][term_id]['content'][language]) {
							translation = window.dictionary[category_id]['terms'][term_id]['content'][language];
						}
					}
				}
			}
		}
	}

	return translation;
}

export function onDictionaryLoaded(callable) {
	if (dictionary !== null) {
		callable();
	} else {
		const listener = document.addEventListener('dictionary_loaded', (e) => {
			callable();
			// document remove event listener dictionary_loaded
			document.removeEventListener('dictionary_loaded', listener);
		});
	}
}


export function centerElementIntoScroll(element, container, offsetTop = 0) {
	let bound = element.getBoundingClientRect();
	container.scrollTo(0, ((bound.top + ((container.scrollTop - offsetTop) - container.offsetTop)) + (bound.height / 2) - (container.offsetHeight / 2)));
}

export function destructWYSIWYG(container) {
	if (container.find('.wysiwyg').length > 0) {
		for (const el of container.find('.wysiwyg')){
			$(el).trumbowyg('destroy');
		}
		container.find('.wysiwyg').removeClass('rb_plugin_loaded');
	}
}

export function handleSelectDropdownPosition() {
	let select = document.querySelectorAll('.select2.select2-container--open');
	select = select[select.length - 1];
	let dropdown = document.querySelectorAll('.select2-dropdown');
	dropdown = dropdown[dropdown.length - 1];
	if (!select || !dropdown) return;
	let dropdownContainer = dropdown.parentElement;
	requestAnimationFrame(() => {
		let selectBounds = select.getBoundingClientRect();
		let dropdownBounds = dropdown.getBoundingClientRect();
		if (select.classList.contains('select2-container--below')) dropdownContainer.style.top = ((selectBounds.top + selectBounds.height) * window.ViewportChildrenScale) + 'px';
		if (select.classList.contains('select2-container--above')) dropdownContainer.style.top = ((selectBounds.top - dropdownBounds.height) * window.ViewportChildrenScale) + 'px';
		dropdownContainer.style.left = (selectBounds.left * window.ViewportChildrenScale) + 'px';
	});
}


export async function setWYSIWYG(target) {
	$.trumbowyg.svgAbsoluteUseHref = true;
	$.trumbowyg.svgPath = '/public/rubberduck/images/SVG/Trumbowyg/icons.svg';
	for (let i = 0; i < $(target).length; i++) {
		if ($($(target)[i]).parents('.field_wrapper').first().find('.trumbowyg-box').length === 0) {
			$($(target)[i]).trumbowyg({
				svgAbsoluteUsePath:true,
				resetCss: true,
				removeformatPasted: true,
				lang: window.current_language,
				tagsToRemove: ['script', 'link', 'style', 'iframe', 'object', 'embed', 'applet', 'base', 'basefont', 'frame', 'frameset', 'head', 'html', 'meta', 'noframes', 'noscript', 'title'],
				btns: [
					['viewHTML'],
					['strong', 'underline', 'em'],
					['superscript', 'subscript'],
					['unorderedList', 'orderedList'],
					['formatting', 'fontsize'],
					['link'],
					['justifyLeft', 'justifyRight', 'justifyCenter', 'justifyFull'],
					['historyUndo', 'historyRedo'],
					['removeformat', 'fullscreen'],
				],
			});
			$($(target)[i]).addClass('rb_plugin_loaded');
		}
	}
}

export function setAutocomplete(target) {
	$(target).each(function () {
		const ac = new Autocomplete($(this)[0]);
		ac.init();

		$(this).addClass('rb_plugin_loaded');
	});
}

export function setColorPicker(target) {
	// https://www.cssscript.com/color-picker-pro/
	let options = {
		format: 'hex'
	};
	if ($(target).length) {
		$(target).each(function () {
			if (!$(this).hasClass('rb_plugin_loaded')) {
				var $this = $(this);
				options['color'] = $this.val();
				if ($this.attr('data-placement') != undefined) {
					options['placement'] = $this.attr('data-placement');
				}
				if ($this.attr('data-format') != undefined) {
					options['format'] = $this.attr('data-format');
				}
				if ($this.attr('data-hexOnly') != undefined) {
					options['hexOnly'] = $this.attr('data-hexOnly');
				}

				let colorPicker = new window.defaultPicker($this[0], options);
				$this.data('ColorPicker', colorPicker);
				$this.closest('.color_field_input').find('.color_preview').css('background-color', $this.val());
				colorPicker.afterShow = () => {
					const picker = $(this).data('ColorPicker');
					picker.setColor(this.value);
					picker.update();
				}
				colorPicker.on("change", function (color) {
					$this.closest('.color_field_input').find('input').trigger('change');
					$this.closest('.color_field_input').find('.color_preview').css('background-color', color.hex);
				});
				let popup = $('#' + colorPicker.id);
				if (popup.length == 1 && popup.find('.colorpicker-close').length == 0) {
					popup.prepend('<span class="colorpicker-close fal fa-times"></span>');
				}
			}
		});
		$body.on('click', '.colorpicker .colorpicker-close', function (e) {
			let popup = $(this).closest('.colorpicker').removeClass('is-opened');
		});
		$(target).addClass('rb_plugin_loaded');
	}
}

export function setSortable(target, children, handle) {
	let options = {
		update: function (e, ui) {
			$(this).find(children).each(function (index, elem) {
				elem.dataset.order = index;
			});
		},
		sort: function(e, ui) {
			ui.item.css('top', 'calc(' + ui.position.top + 'px * var(--viewport_children_scale))')
			ui.item.css('left', 'calc(' + ui.position.left + 'px * var(--viewport_children_scale))')
		}
	};
	if (handle !== '') {
		options['handle'] = handle;
	}
	$(target).sortable(options);
	$(target).addClass('rb_plugin_loaded');
}

let z_count = 1;
export function setSelectLinksPlugin(target, action) {
	let $selects = $(target).filter(':not(.select2-hidden-accessible)');
	let select2_options = {
		debug: true,
		width: false,
		theme: '',
		language: window.lang,
		ajax: {
			url: action,
			type: 'POST',
			data: function (params) {
				let formData = new FormData();
				formData.append('language', $(this).data('language'));
				formData.append('slug_to_search', params.term || '');
				formData.append('current_selected_id', $(this).val());
				formData.append('page', params.page || 1);
				return formData;
			},
			dataType: 'json',
			contentType: false,
			cache: false,
			processData: false,
			processResults: function (data) {
				handleSelectDropdownPosition();
				return {
					results: data.options,
					pagination: {
						more: data.has_next
					}
				};
			}
		}
	}

	// Loops through all selects
	for (let i = 0; i < $selects.length; i++) {
		const $el = $selects.eq(i);

		// if ($el.closest('.choice, .section_choice').length == 0) {
		// 	// Set inline parent container
		// 	select2_options.dropdownParent = $el.parent();
		// } else {
		// 	delete select2_options.dropdownParent;
		// }

		// Init select2
		$el.select2(select2_options)
			.on('select2:open', function (e) {
				handleSelectDropdownPosition();
				let $dropdown = $(e.target).parent().find('.select2-dropdown');

				// Increment higher z-index
				$dropdown.first().closest('.field_wrapper, .table_head').css('z-index', z_count++);

				// Slide down animation
				$dropdown.hide().delay(1).slideDown(250);

				// Search
				$('.select2-search__field').attr('placeholder', (window.lang == 'fr' ? 'Recherche' : 'Search'));

				// Add pageable from internal link dropdown
				$('select.is_add_pageable_target').removeClass('is_add_pageable_target');
				let select2 = document.querySelectorAll('.select2.select2-container--open');
				select2 = select2[select2.length - 1];
				select2.parentNode.querySelector('select').classList.add('is_add_pageable_target');
				let append_element = select2.parentNode.querySelector('.select_append');
				let dropdown = document.querySelectorAll('.select2-dropdown');
				dropdown = dropdown[dropdown.length - 1];
				if (!append_element || !dropdown || dropdown.querySelector('.add_pageable_container')) return;
				let clone = append_element.cloneNode(true);
				clone.classList.remove('select_append');
				let div = document.createElement('div');
				div.classList.add('add_pageable_container');
				div.innerHTML = clone.outerHTML;
				requestAnimationFrame(() => {
					dropdown.append(div);
					handleSelectDropdownPosition();
				});
			})
			.on('select2:closing', function (e) {
				if ($(e.target).hasClass('never_close')) {
					e.preventDefault();
				} else {
					$(e.target).closest('.field_wrapper, .table_head').css('z-index', '');
				}
			})
			.on('select2:closed', function (e) {
				if ($(e.target).hasClass('never_close')) {
					$(e.target).select2('open');
				}
			});
	}
	$selects.addClass('rb_plugin_loaded');
}

export function setSelectPlugin(target) {
	let $selects = $(target).filter(':not(.select2-hidden-accessible)');
	let select2_options = {
		debug: true,
		width: false,
		minimumResultsForSearch: Infinity, // Hide the search input
		theme: '',
		language: window.lang
	}

	// Loops through all selects
	for (let i = 0; i < $selects.length; i++) {
		const $el = $selects.eq(i);

		// if ($el.closest('.choice, .section_choice').length == 0 && !$el.hasClass('global')) {
		// 	// Set inline parent container
		// 	select2_options.dropdownParent = $el.parent();
		// } else {
		// 	delete select2_options.dropdownParent;
		// }

		// Init select2
		$el.select2(select2_options)
			.on('select2:open', function (e) {
				handleSelectDropdownPosition();

				let $dropdown = $(e.target).parent().find('.select2-dropdown');
				// Increment higher z-index
				$dropdown.first().closest('.field_wrapper, .table_head').css('z-index', z_count++);

				// Slide down animation
				$dropdown.hide().delay(1).slideDown(250);

				// Search
				$('.select2-search__field').attr('placeholder', (lang == 'fr' ? 'Recherche' : 'Search'));
			})
			.on('select2:closing', function (e) {
				if ($(e.target).hasClass('never_close')) {
					e.preventDefault();
				} else {
					$(e.target).closest('.field_wrapper, .table_head').css('z-index', '');
				}
			})
			.on('select2:closed', function (e) {
				if ($(e.target).hasClass('never_close')) {
					$(e.target).select2('open');
				}
			});
	}

	$selects.addClass('rb_plugin_loaded');
}

export /**
* Center an element based on the reference position
* @param <HTMLElement|null> 	element				The element to move around
* @param <HTMLElement|null> 	reference			The reference for the element position
* @param <string>				position			Where to position the element compared to the reference (top, bottom, right, left)
* @param <bool>				try_other_position	If it's out of bounds from position, try other position or not
* @param <bool>				hide				If it's out of bounds from position, do we hide the element or not by removing the class "active" on the element
* @param <int>					spacing				Spacing between the reference and element and for the viewport buffer to detect if it's out of bounds
*/
function setFixedElementPosition(
	{
		element = null,
		reference = null,
		position = 'top',
		try_other_position = true,
		hide = false,
		spacing = 5
	} = {}
) {
	if (element instanceof HTMLElement && reference instanceof HTMLElement) {
		const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
		const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
		let element_bounds = element.getBoundingClientRect();
		let reference_bounds = reference.getBoundingClientRect();

		// Calc position
		let top = 0;
		let left = 0;
		if (position == 'top') {
			top = reference_bounds.top - element_bounds.height - spacing;
			left = reference_bounds.left + (reference_bounds.width / 2) - (element_bounds.width / 2);
		} else if (position == 'bottom') {
			top = reference_bounds.top + reference_bounds.height + spacing;
			left = reference_bounds.left + (reference_bounds.width / 2) - (element_bounds.width / 2);
		} else if (position == 'right') {
			top = reference_bounds.top + (reference_bounds.height / 2) - (element_bounds.height / 2);
			left = reference_bounds.left + reference_bounds.width + spacing;
		} else if (position == 'left') {
			top = reference_bounds.top + (reference_bounds.height / 2) - (element_bounds.height / 2);
			left = reference_bounds.left - element_bounds.width - spacing;
		}

		// Check if is in bounds
		let out_of_bounds = false;
		let v_x1 = ($('#left_nav').is(':visible') ? $('#left_nav').outerWidth() : 0) + (spacing * 2);
		let v_x2 = vw - (spacing * 2);
		let v_y1 = 0 + (spacing * 2);
		let v_y2 = vh - (spacing * 2);

		if (top < v_y1) {
			top = v_y1;
			out_of_bounds = (position == 'top' || position == 'bottom');
		}
		if ((top + element_bounds.height) > v_y2) {
			top = v_y2 - element_bounds.height;
			out_of_bounds = (position == 'top' || position == 'bottom');
		}
		if (left < v_x1) {
			left = v_x1;
			out_of_bounds = (position == 'left' || position == 'right');
		}
		if ((left + element_bounds.width) > v_x2) {
			left = v_x2 - element_bounds.width;
			out_of_bounds = (position == 'left' || position == 'right');
		}

		if (out_of_bounds) {
			if (try_other_position) {
				if (position == 'top') return setFixedElementPosition({position: 'bottom', try_other_position: false, element: element, reference: reference, hide: hide, spacing: spacing});
				if (position == 'bottom') return setFixedElementPosition({position: 'top', try_other_position: false, element: element, reference: reference, hide: hide, spacing: spacing});
				if (position == 'left') return setFixedElementPosition({position: 'right', try_other_position: false, element: element, reference: reference, hide: hide, spacing: spacing});
				if (position == 'right') return setFixedElementPosition({position: 'left', try_other_position: false, element: element, reference: reference, hide: hide, spacing: spacing});
			}
			if (hide) {
				element.classList.remove('active');
			}
		}

		element.style.top = (top * window.ViewportChildrenScale) + 'px';
		element.style.left = (left * window.ViewportChildrenScale) + 'px';
	}
}

// TODO: bundle error with jquery-ui-timepicker-addon Error parsing the date/time string: Missing number at position
export function setDatepicker(target) {
	$(target).each(function () {
		let $this = $(this);
		let options = {
			showOtherMonths: true,
			selectOtherMonths: true,
			altField: "#datepicker",
			altFieldTimeOnly: "false",
			closeText: 'Fermer',
			prevText: 'Précédent',
			nextText: 'Suivant',
			changeYear: true,
			changeMonth: true,
			currentText: 'Aujourd\'hui',
			monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
			monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avril', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
			dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
			dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
			dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
			weekHeader: 'Sem.',
			dateFormat: ($this.attr('data-format') ? $this.attr('data-format') : 'dd-mm-yy'),
			timeFormat: ($this.attr('data-format') ? $this.attr('data-format') : 'HH:mm'),
			controlType: 'select',
			timeInput: 'true',
			alwaysSetTime: 'false',
			oneLine: 'true',
			timePicker: 'true',
			beforeShow: function (input, inst) {
				requestAnimationFrame(() => {
					setFixedElementPosition({
						element: inst.dpDiv[0],
						reference: input,
						position: 'bottom'
					});
				});
			}
		};

		if ($this.attr('data-datetimepicker') != null) {
			$this.datetimepicker(options);
		} else {
			$this.datepicker(options);
		}

		if ($this.attr('data-min-date') != null) {
			let min_date = $this.attr('data-min-date');
			$this.datepicker('option', 'minDate', min_date);
		}

		if ($this.attr('data-max-date') != null) {
			let max_date = $this.attr('data-max-date');
			$this.datepicker('option', 'maxDate', max_date);
		}

		if ($this.attr('data-first-day') != null) {
			let first_day = $this.attr('data-first-day');
			$this.datepicker('option', 'firstDay', first_day);
		}

		$this.addClass('rb_plugin_loaded');
	});
}

/**
 * Load every plugin inside element without the class rb_plugin_loaded
 *
 * @param {JQueryElement} $element
 * @param {boolean} visibleOnly true if we want to load only visilbe content
 */
export async function loadUnloadedPlugins($element, visibleOnly = false) {
	setDatepicker($element.find('.datepicker:not(rb_plugin_loaded)' + (visibleOnly ? ':visible' : '')));
	setSelectPlugin($element.find('select.select_style:not(rb_plugin_loaded)' + (visibleOnly ? ':visible' : '')));
	setSelectLinksPlugin($element.find('select.link_choice:not(rb_plugin_loaded)' + (visibleOnly ? ':visible' : '')), '/rubberduck/field/link_research');
	setColorPicker($element.find('.color_picker:not(rb_plugin_loaded)' + (visibleOnly ? ':visible' : '')));
	setAutocomplete($element.find('.' + Autocomplete.HTML_CLASS + ':not(rb_plugin_loaded)' + (visibleOnly ? ':visible' : '')));
	await setWYSIWYG($element.find('.wysiwyg:not(rb_plugin_loaded)' + (visibleOnly ? ':visible' : '')));
	// TODO: target only the unloaded checkbox
	let handler = new checkboxListHandler();
	handler.load();
	return true;
}

export function removeFormErrors($selector) {
	$selector.find('.invalid').removeClass('invalid');
	$selector.find('.show_on_error').slideUp(function () {
		$(this).remove()
	});
}

export function handleCustomPopupOverflow() {
	if ($('.custom_popup:visible').length > 0) {
		let container = $('.custom_popup:visible .container');
		let content = container.find('.content');

		let content_max_height = parseInt(content.css('max-height'));
		let content_height = parseInt(content.outerHeight());

		if (content_height >= content_max_height) {
			container.addClass('overflow');
		} else {
			container.removeClass('overflow');
		}
	}
}


export function tablesorterUpdate($tab, callback) {
	let $pager = $tab.find('.tablesorter_pager')
	let $table = $tab.find('.tablesorter_list');
	let $form = $tab.find('.tablesorter_filter');
	let isInit;

	let pagerOptions = {
		container: $pager,
		output: function (table, pager) {
			$pager.find('.pagesize').trigger('change');
			let pagesToShow = 5;
			let current = pager.page + 1;
			let pages = [];
			let html = '';

			if (pager.filteredPages < pagesToShow) {
				// Total of pages is lesser than pages to show
				for (let i = 1; i <= pager.filteredPages; i++) {
					pages.push(i);

				}
			} else if (current - Math.floor(pagesToShow / 2) < 1) {
				// Current page is lesser or equal to half of the pages to show
				for (let i = 1; i <= pagesToShow; i++) {
					pages.push(i);
				}
			} else if (current + Math.floor(pagesToShow / 2) > pager.filteredPages) {
				// Current page is greater or equal to the pages's total minus half of the pages to show
				for (let i = 1; i <= pagesToShow; i++) {
					pages.push(pager.filteredPages + i - pagesToShow);
				}
			} else {
				// Default behaviour
				for (let i = 1; i <= pagesToShow; i++) {
					pages.push(current - Math.ceil(pagesToShow / 2) + i);
				}
			}

			for (let i = 0; i < pages.length; i++) {
				const e = pages[i];
				html += '<span class="page' + (e == current ? ' current' : '') + '" data-page="' + e + '">' + e + '</span>';;
			}

			return html;
		},
		updateArrows: true,
		size: 50,
		savePages: true, // Save current page and size so on refresh it stays the same
		storageKey: 'tablesorter-pager',
		pageReset: 0,
		fixedHeight: false,
		removeRows: false,
		countChildRows: false,
		cssNext: '.next', // next page arrow
		cssPrev: '.prev', // previous page arrow
		cssFirst: '.first', // go to first page arrow
		cssLast: '.last', // go to last page arrow
		cssGoto: '.gotoPage', // select dropdown to allow choosing a page
		cssPageDisplay: '.pagedisplay', // location of where the "output" is displayed
		cssPageSize: '.pagesize', // page size selector - select dropdown that sets the "size" option
		cssDisabled: 'disabled', // Note there is no period "." in front of this class name
		cssErrorRow: 'tablesorter-errorRow' // ajax error information row
	};

	let action = $table.attr('data-action');
	let method = $table.attr('method');
	if (null == method) {
		method = 'POST';
	}
	if (action != undefined) {
		let ajax_options = {
			ajaxUrl: action + '?page={page}&size={size}&{sortList:sort}',
			ajaxError: null,
			ajaxObject: {
				type: method,
				data: $form.find('input, select, textarea').serialize(),
				dataType: 'json',
				beforeSend: function () {
					ajaxPreloader();
				},
				complete: function () {
					closeAjaxPreloader();
					fixActionCells($tab);
				}
			},
			ajaxProcessing: function (data, table, xhr) {
				if (data && data.status && data.message) {
					displayNotification(data.status, data.message, data?.notification);
				}
				if (data != null && ((data.total != null && data.total > 0) || (data.max != null && data.max > 0))) {
					let tbody = $table.find('tbody').first();
					if (window['MutationObserver']) {
						const mutationCallback = (mutations, observer) => {
							if (mutations.length > 0 && mutations[0].type == 'childList') {
								document.dispatchEvent(new CustomEvent('tablesorter:pager:change'));
							} 
						}
						const observer = new MutationObserver(mutationCallback);
						observer.observe(tbody[0], {childList: true});
					}
					// REFACTOR_PAGEABLE_FINDER
					let html = '';
					if (typeof callback === 'string') {
						html = window[callback](data.objects);
					} else if (typeof callback === 'function') {
						html = callback(data.objects);
					} else if (typeof data.data !== 'undefined') {
						html = data.data;
					}
					tbody.html(html);
					if ($('.actions_cell.actions_hidden').length > 0) {
						$('.actions_cell').addClass('actions_hidden');
					}
					setSelectPlugin('.tablesorter select.select_style');
					
					// Makes the entire row clickable, except for togglable cells.
					let $links = $('.cell_content h3 a');

					$links.each(function(){
						let url = $(this).attr('href');
						let $row = $(this).closest('tr');
						let $cells = $row.find('.cell_wrapper');

						$cells.each(function(){
							if($(this).find('.info_window--toggle').length === 0){
								$(this).prepend('<span class="hidden_link"><a href="'+ url +'"></a></span>')		
							}
						})
					});
					if (!window['MutationObserver']) {
						requestAnimationFrame(() => {
							document.dispatchEvent(new CustomEvent('tablesorter:pager:change'));
						});
					}

					return [(data.max ?? data.total)];
				} else {
					return [0];
				}
			},
			processAjaxOnInit: true
		};
		Object.assign(pagerOptions, ajax_options);
	}

	$table.tablesorter({
		sortLocaleCompare: true, // needed for accented characters in the data
		dateFormat: "ddmmyyyy",
		widgets: ['zebra'],
		textExtraction: function (node, table, cellIndex) {
			return $(node).attr('data-sort-value') || $(node).text();
		}
	})
		.bind('pagerChange pagerComplete pagerInitialized pageMoved', function (e, c) {
			let msg = '"</span> event triggered, ' + (e.type === 'pagerChange' ? 'going to' : 'now on') + ' page <span class="typ">' + (c.page + 1) + '/' + c.totalPages + '</span>';
			$('#display')
				.append('<li><span class="str">"' + e.type + msg + '</li>')
				.find('li:first').remove();
		})
		.tablesorterPager(pagerOptions);

	// Page Go To
	if (!isInit) {
		isInit = true;
		$body.on('click', '.tablesorter_pager .page', function () {
			$table.trigger('pageAndSize', $(this).data('page'));
		});
	}
}

export function fixActionCells($tab) {
	if (typeof $tab === 'undefined') {
		$tab = $('body');
	}

	$tab.find('table.actions_table tbody').empty();

	// Fixed Action cells
	let $header = $tab.find('th.actions_cell');
	let $wrappers = $tab.find('td.actions_cell');
	let $actionsTable = $tab.find('table.actions_table');
	let $actionsTableHead = $actionsTable.children('thead');
	let $actionsTableBody = $actionsTable.children('tbody');
	let $actionsHidden = $tab.find('.actions_hidden');

	// Move actions_cell to absolute table
	// Table head
	if ($actionsTable.find('th').length > 0) {
		// Already has a header
		$tab.find('table.actions_table thead').empty();
	}
	$actionsTableHead.append('<tr></tr>');
	$actionsTableHead.find('tr:last-child').append($header);
	// Table body
	for (let i = 0; i < $wrappers.length; i++) {
		let rowClasses = $wrappers.eq(i).closest('tr').attr('class');
		let data = $wrappers.eq(i).closest('tr').data();
		let data_html = '';
		$.each(data, function (name, value) {
			data_html += 'data-' + name + '="' + value + '"';
		});
		$actionsTableBody.append('<tr class="' + rowClasses + '" ' + data_html + '></tr>');
		$actionsTableBody.find('tr:last-child').append($wrappers.eq(i));
	}

	// If actions are hidden, show them to get the real width
	if ($actionsTableBody.find('.actions_hidden').length > 0) {
		$actionsHidden = $('.actions_hidden').removeClass('actions_hidden');
	}

	// Set actions_cell width
	let width = $wrappers.outerWidth();
	// Set overflow container padding
	$('.overlay_scroll_x').closest('.table_wrapper').css('padding-right', width);

	// Hide back the action cells if they were hidden;
	if ($actionsHidden.length > 0) {
		$actionsHidden.addClass('actions_hidden');
	}
}

export function setActionPopup($target) {
	if ($target !== null) {
		var $tr = $target.closest('tr, .table_row');
		if ($tr.length) {
			let popup = $('#popup.popup_row');
			popup.css('top', $tr.offset().top * window.ViewportChildrenScale);
			if (popup.find('> div > .flex')) {
				let wrapper = $tr.closest('.table_wrapper');
				popup.css({
					'left': (wrapper.offset().left * window.ViewportChildrenScale),
					'width': wrapper.outerWidth()
				});
				popup.find('> div > .flex').css('height', $tr.outerHeight());
			} else {
				popup.find('.cell_wrapper').css('height', $tr.outerHeight());
			}
		}
	}
}

export function submitMeAjax(form, jata) {
	let action = form.getAttribute('data-action');
	if (action == null) {
		action = form.getAttribute('action');
	}
	removeFormErrors($(form));
	submitted_form = $(form);
	return callMeAjax(action, jata).done(function (data) {
		if (data.status === 'success') {
			if ($(form).attr('data-reset') == 'true') {
				let handler = new checkboxListHandler();
				handler.reset();
				form.reset();

				$(form).find('.wysiwyg').each(function () {
					$(this).trumbowyg('html', '');
				});
				$(form).find('.url_field').val('');
				$(form).find('.file_input .pic, .media_field_input_wrapper .image').css('background-image', '');
				$(form).find('.file_input').addClass('hover');

				if ($(form).find('select.select_style').length > 0) {
					$(form).find('select.select_style').trigger('change');
				}
			}
			if (typeof data.trigger !== "undefined" && data.trigger !== null) {
				switch (data.trigger) {
					case "close_popup":
						$(form).parents('.custom_popup').find('.curtain').trigger('click');
					break;
				}
			}
		} else {
			handleErrors(form, data.error_input, data.field_validation_errors);
		}
	});
}

/**
 * Read URL, load IMG url
 */
export function readURL(input) {
	if (input.files && input.files[0]) {
		var reader = new FileReader();

		reader.onload = function (e) {
			if ($(input).closest('.image').length > 0) {
				var image_holder = $(input).closest('.image');
			} else if ($(input).siblings('.image').length > 0) {
				var image_holder = $(input).siblings('.image');
			}

			if (image_holder) {
				let image_path = e.target.result;

				let show_image = true;
				if (image_holder.next().hasClass('fields')) {
					if (image_holder.next().find('.url').length == 1) {
						if (image_holder.next().find('.url').val() === '') {
							show_image = false;
						}
					}
				}

				if (image_holder.parent().hasClass('file_field_input')) {
					// show_image = false;
					let image_types = ['image/gif', 'image/jpeg', 'image/png', 'image/webp'];
					if ($.inArray(input.files[0]['type'], image_types) === -1) {
						image_path = '/public/rubberduck/images/file.png';
					}
				}
				if (show_image) {
					image_holder.css('background-image', "url(" + image_path + ")");
					image_holder.parent().find('.media_id').val('');
					image_holder.find('.add').addClass('hide');
					image_holder.closest('.media_field_input_wrapper').find('.actions_btn .delete_media, .actions_btn .replace').removeClass('hide');
					image_holder[0].dispatchEvent(new CustomEvent('image:updated'));
				}
			} else {
				if ($(input).next().hasClass('pic')) {
					$(input).next().css('background-image', "url(" + e.target.result + ")");
				} else if ($(input).closest('#user.user_interface').length) {
					$(input).closest('label').find('.profile_picture').css('background-image', "url(" + e.target.result + ")");
				} else if ($(input).siblings('img').length) {
					let img = $(input).siblings('img');

					img.attr('src', e.target.result);
					if (img.hasClass('to_crop')) {
						window.RDCropper.resetImage(img);
					}
				} else if ($(input).siblings('.img--container').length) {
					$(input).siblings('.media_id').val('');
					$(input).siblings('.img--container').find('img.to_crop').attr('src', e.target.result);

					window.RDCropper.resetImage($(input).siblings('img.to_crop'));
				}
			}
		}
		reader.readAsDataURL(input.files[0]);
	}
}

export function viewport() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

export function cleanString(url) {
	url = url.replace(/ /g, '-');
	url = url.replace(/,/g, '-');
	url = url.replace(/_/g, '-');
	url = url.replace(/<</g, '«');
	url = url.replace(/>>/g, '»');
	url = url.replace(/<>/g, '-');
	url = url.replace(/</g, '-');
	url = url.replace(/>/g, '-');
	url = url.replace(/:/g, '-');
	url = url.replace(/;/g, '-');
	url = url.replace(/\./g, '-');
	url = url.replace(/\//g, '-');
	url = url.replace(/&/g, '-');
	url = url.replace(/Œc/g, 'oe');
	url = url.replace(/œ/g, 'oe');
	url = url.replace(/Æ/g, 'ae');
	url = url.replace(/æ/g, 'ae');
	url = url.replace(/\'/g, '-');
	url = url.replace(/\’/g, '-');
	url = url.replace(/\"/g, '-');
	url = url.replace(/\?/g, '');
	url = url.replace(/`/g, '');
	url = url.replace(/\^/g, '');
	url = url.replace(/!/g, '');
	url = url.replace(/&([eaiouc]).*?;/i, '$1');
	url = url.replace(/-+/g, '-');
	url = url.replace(/%/g, '');
	url = url.replace(/\(/g, '');
	url = url.replace(/\)/g, '');
	url = url.replace(/#/g, '');
	url = url.replace(/∙/g, '-');
	url = url.toLowerCase();

	url = url.split('');
	var urlOut = new Array();
	var urlLen = url.length;
	var accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
	var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";
	for (var y = 0; y < urlLen; y++) {
		if (accents.indexOf(url[y]) != -1) {
			urlOut[y] = accentsOut.substr(accents.indexOf(url[y]), 1);
		} else
			urlOut[y] = url[y];
	}
	url = urlOut.join('');

	return url;
}
